import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from '@emotion/react'
import DocumentHeaders from './components/layout/DocumentHeaders'
import Routes from './routes/index'
import { Page } from './components/page'
import serverData from './utils/server-data'
import ApplicationContextProvider from './context/ApplicationContext'
import './styles/globals.scss'
import './components/common/analytics/fpti'
import { PAYPAL_THEME } from '@paypalcorp/pp-react'
import ScrollToTop from './utils/scroll-to-top'

function App() {
  return (
    <div id="app" data-testid='dashboard-container-v5'>
      <ApplicationContextProvider>
        <DocumentHeaders />
        <ThemeProvider theme={PAYPAL_THEME}>
          <DocumentHeaders />
          <BrowserRouter basename={serverData.requestURI}>
            <ScrollToTop />
            <Page>
              <Routes />
            </Page>
          </BrowserRouter>
        </ThemeProvider>
      </ApplicationContextProvider>
    </div>
  )
}

export default App
